import { PixelEventName } from "../types";
import { customEvent, pixelCustomEvent } from "./customEvent";
import { isMobile } from "./isMobile";

export const call = (callNumber: string | "1666-9784", isUrgent = false) => {
  const isGoiCall = callNumber === "1666-9784";
  customEvent({
    newGtm: {
      action: isGoiCall ? "goi_call" : "call",
    },
    triggerHackle: true,
  });

  /**
   * 픽셀 Lead 는 고이로 연결될 때만 쏜다.
   *
   * 예전에는 번호를 안 보고 무조건 쐈다. 호출부가 전부 고이 대표번호일 때는 문제가
   * 없었지만, 상조사 직통이나 화장장 직통처럼 고이로 오지 않는 통화까지 Meta 에
   * Lead 전환으로 신고돼 광고 최적화가 오염된다.
   */
  if (isGoiCall) {
    pixelCustomEvent(PixelEventName.Lead);
  }

  if (isGoiCall && !isUrgent) {
    const now = new Date().getUTCHours();
    const currentKoreanHour = (now + 9) % 24;

    if (currentKoreanHour >= 2 && currentKoreanHour < 7) {
      alert(
        "고이장례연구소 고객센터: 새벽 2시~6시에는 임종 접수, 긴급 상담만 가능합니다. 다른 문의는 오전 6시 이후 가능합니다.(임종접수/긴급상담: 1666-9784)"
      );
      return;
    }
  }
  if (isMobile()) {
    location.href = `tel:${callNumber}`;
  } else {
    alert("전화번호: " + callNumber);
  }
};
